'use strict';

(function () {
    'use strict';

    appRun.$inject = ['routerHelper'];
    angular.module('app.iot').run(appRun);

    function appRun(routerHelper) {
        'ngInject';

        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [{
            state: 'iot',
            config: {
                url: '/iot',
                component: 'iotIndex'
            }
        }, {
            state: 'historical-data',
            config: {
                url: '/historical-data?water',
                component: 'historicalData',
                params: {
                    category: { value: null, array: false },
                    categories: { value: null, array: false }
                }
            }
        }, {
            state: 'streaming-data',
            config: {
                url: '/streaming-data',
                component: 'streamingData'
            }
        }, {
            state: 'infrastructure-map',
            config: {
                url: '/infrastructure-map',
                component: 'infrastructureMap'
            }
        }];
    }
})();